import * as React from 'react';
import ContextMenuData from './ContextMenuData';
import ContextMenuDataItem from './ContextMenuDataItem';
import createAddinContextMenuDataItem from './createAddinContextMenuDataItem';
import createOverflowContextMenuData from './createOverflowContextMenuData';
import executeEntryPoint from '../utils/entryPointOperations/executeEntryPoint';
import { Addin, AddinCommand } from 'owa-addins-store';
import { AddinCommandSurfaceItem, ContextMenuDataItemClick } from 'owa-addins-types';
import { createAddinMarketplaceItem, createDivider } from './AddinMarketplaceItem';
import { isFeatureEnabled } from 'owa-feature-flags';

export function getClickHandler(command: AddinCommand): ContextMenuDataItemClick {
    return (hostItemIndex: string) => {
        return (event?: React.MouseEvent<HTMLElement>) => {
            event.stopPropagation();
            executeEntryPoint(hostItemIndex, command);
        };
    };
}

export function createAddinCommandSurfaceAction(addin: Addin): AddinCommandSurfaceItem {
    const menuData: ContextMenuDataItem = createAddinContextMenuDataItem(addin);
    return menuData.generateData();
}

export function createAddinCommandSurfaceActions(addins: Addin[]): AddinCommandSurfaceItem {
    const menuData: ContextMenuData = createOverflowContextMenuData(addins);
    const actions = menuData.generateData();

    if (isFeatureEnabled('addin-inClientStoreEnabled')) {
        actions.sectionProps.items.push(createDivider());
        actions.sectionProps.items.push(createAddinMarketplaceItem());
    }

    return actions;
}
